module.exports = __webpack_public_path__ + "static/media/50.40af5490.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/monuments/polished/50.jpg
// module id = 611
// module chunks = 0